module.exports = __webpack_public_path__ + "media/images/twitter-1-c03c8a672421792c655852ebc45e9f22.png";